import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/pro-regular-svg-icons";
import { FormattedMessage } from "react-intl";

import ImgEmptyNotification from "../../../../assets/img/empty_notification.svg";
import "./style.css";

const EmptyNotification = () => (
  <div className="empty-notification">
    <img src={ImgEmptyNotification} className="empty-notification-image" alt="empty-notification" />
    <div className="empty-notification-message">
      <FormattedMessage id="notification.noNotification" />
    </div>
    <div className="empty-notification-suggestion">
      <FontAwesomeIcon icon={faRedo} /> <FormattedMessage id="notification.refreshNotificationSuggestion" />
    </div>

  </div>
);

export default EmptyNotification;
